import { DialogTitle, styled as muiStyled } from '@mui/material'

export const CongratulatoryTimerHeader = muiStyled(DialogTitle)(
  ({ theme }) => `
    display: flex;
    justify-content: space-between;
    align-items:center;
    color: #fff;
    font-size: 30px;
`,
)
